import { z } from 'zod';

/**
 * v3 schema for clipboard selection data: carries the pre-serialized HTML-like
 * Cast context (from `serializeSelectionContext`) instead of structured
 * paragraphs, mirroring the v3 selection mention.
 */
export const AlineSelectionClipboardDataV3Schema = z.object({
  documentId: z.string(),
  documentName: z.string(),
  focusSuggestionId: z.string().nullable(),
  html: z.string(),
});

export type AlineSelectionClipboardDataV3 = z.infer<typeof AlineSelectionClipboardDataV3Schema>;

/**
 * Schema for consolidated clipboard data stored in data-aline-clipboard attribute.
 * Contains both the slate fragment (encoded) and optional selection data.
 */
export const AlineClipboardDataSchema = z.object({
  documentId: z.string().optional(),
  selection: z.string().optional(),
  slate: z.string(),
});

export type AlineClipboardData = z.infer<typeof AlineClipboardDataSchema>;
